import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { breakpoints } from '../../../../constants/breakpoits.constants'

const StyledInformation = styled.div`
	justify-content: center;
	padding-bottom: 1rem;
`
const StyledPointsInformation = styled.p`
	text-align: center;
	font-size: 18px;
	line-height: 24px;

	@media (min-width: ${breakpoints.MOBILE}px) {
		font-size: 2.4rem;
		line-height: 3.4rem;
	}
`

class PointsInformationComponent extends Component {
	render() {
		const {
			balancePoints,
			expiringPoints,
			clientPointsWasLoaded
		} = this.props
		return !clientPointsWasLoaded ||
			balancePoints === null ||
			expiringPoints === null ? null : (
				<StyledInformation>
					<StyledPointsInformation>
						Saldo atual{' '}
						<span className="bold blue">
							{Number(balancePoints).toLocaleString('pt-BR')}
						</span>{' '}
					pontos Muviflex <br />
						{/* <span className="bold orange">
						{Number(expiringPoints).toLocaleString('pt-BR')}
					</span>{' '}
					pontos expirando em 30 dias */}
					</StyledPointsInformation>
				</StyledInformation>
			)
	}
}

const mapStateToProps = ({ client }) => ({
	...client
})

const PointsInformation = connect(
	mapStateToProps,
	null
)(PointsInformationComponent)

export default PointsInformation
